export abstract class Configuration {}
